import React from "react";
import BulkPaymentHero from "./bulk-payment/BulkPaymentHero";
import WorkSmarter from "./bulk-payment/WorkSmarter";
import JoinNetwork from "./bulk-payment/JoinNetwork";
import WorkPayment from "./bulk-payment/WorkPayment";
import svg98 from "../../../assets/svg/svg98.svg";   
import svg108 from "../../../assets/svg/svg108.svg";
import svg109 from "../../../assets/svg/svg109.svg";
import svg111 from "../../../assets/svg/svg111.svg";
import svg112 from "../../../assets/svg/svg112.svg";
import img6 from "../../../assets/img/img6.png";  
import svg116 from "../../../assets/svg/svg116.svg"; 
import svg118 from "../../../assets/svg/svg118.svg";
import svg119 from "../../../assets/svg/svg119.svg";
import svg120 from "../../../assets/svg/svg120.svg";
import svg121 from "../../../assets/svg/svg121.svg";
import svg122 from "../../../assets/svg/svg122.svg";
import svg123 from "../../../assets/svg/svg123.svg";

const itemsHero = [
  {
    title: "Digitized Requests & Approvals",
    svg: svg118,
    desc: "Replace manual vouchers with an easy, transparent online request and approval system.",
  },
  {
    title: "Automated Expense Tracking",
    svg: svg119,
    desc: "Track every transaction in real time to identify trends, control misuse, and improve accountability.",
  },
  {
    title: "Instant Wallet Top-Ups",
    svg: svg98,
    desc: "Fund teams or field agents instantly through Ndovu Pay wallets, no physical cash required.",
  },
];
const titleHero = "Gain Total Control Over Daily Expenses";
const subtitleHero =
  "Digitize petty cash requests, approvals, and disbursements ensuring every shilling is tracked, transparent, and fully accounted for.";

const itemsSmarter = [
  {
    title: "Eliminate Paperwork",
    svg: svg120,
    desc: "Digitize petty cash requests and approvals to remove manual handling and delays.",
  },
  {
    title: "Smarter Budgeting",
    svg: svg121,
    desc: "Monitor spending by department, set limits, and stay within budget effortlessly.",
  },
  {
    title: "Faster Reimbursements",
    svg: svg122,
    desc: "Disburse funds instantly to teams and field agents, keeping operations moving.",
  },
  {
    title: "Improve Transparency",
    svg: svg116,
    desc: "Gain complete visibility. Every transaction is tracked, approved, and auditable.",
  },
    {
    title: "Simplify Audits",
    svg: svg123,
    desc: "Generate detailed reports in seconds for clear, compliant financial reviews.",
  },
];

const titleSmarter = "Built to Make Cash Management Effortless";
const subtitleSmarter =
  "Go digital, save time, and stay fully in control of your operational expenses.";

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Submit Request",
    desc: "Staff raise a request detailing purpose and amount.",
  },
  {
    svg: svg109,
    title: "Review & Approve",
    desc: "Managers approve or decline instantly based on workflow settings. ",
  },
  {
    svg: svg111,
    title: "Disburse Funds",
    desc: "Approved requests are funded instantly via wallet or linked account.",
  },
  {
    svg: svg112,
    title: "Report & Reconcile",
    desc: "Receipts are uploaded, expenses tagged, and transactions closed with a few clicks.",
  },
];

const titleWorkPayment = "How Bill Payments & Settlements Work";
const subtitleWorkPayment =
  "Process all your supplier and utility payments in four simple steps";
const title="Join the growing network of organizations using Ndovu Pay"
    const subtitle= "Experience the future of business payments with Ndovu Pay"
function CashManagement({ setActive }) {
  return (
    <div id="petty-cash">
      <BulkPaymentHero
        items={itemsHero}
        title={titleHero}
        subtitle={subtitleHero}
        svg101={img6}
      />
      <WorkSmarter
        items={itemsSmarter}
        title={titleSmarter}
        subtitle={subtitleSmarter}
      />
      <WorkPayment
        items={itemsWorkPayment}
        title={titleWorkPayment}
        subtitle={subtitleWorkPayment}
      />
      <JoinNetwork title={title} subtitle={subtitle} setActive={setActive}/>
    </div>
  );
}

export default CashManagement;
